<template>
    <div>
        <b-modal id="adicionar-usuario" centered body-class="modal-form-width body-class container px-3 pt-2 pb-0" no-close-on-backdrop no-close-on-esc size="lg"
        footer-class="pt-0" @hidden="$emit('close')" :visible="true"> 
            <template #modal-title >
                <DynamicIcon :icon="usuarioId != null ? 'pencil': 'head-brain'" classString="container-modal-title-icon mr-2"/>
                {{usuarioId != null ? "Editar" : "Adicionar"}} Usuário
            </template>
            <div class="row m-0">
                <b-form-group label="Nome" label-for="nomeUsuario" class="col-12 col-md-6 px-1">
                    <b-form-input id="nomeUsuario" placeholder="Digite aqui" :state="state.nome" v-model="form.name" trim maxlength="150"/>
                    <b-form-invalid-feedback :state="state.nome">{{validateMessage.nome}}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="E-mail" label-for="emailUsuario" class="col-12 col-md-6 px-1">
                    <b-form-input id="emailUsuario" placeholder="Digite aqui" :state="state.email" v-model="form.email" trim maxlength="100"/>
                    <b-form-invalid-feedback :state="state.email">{{validateMessage.email}}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="CPF" label-for="cpfUsuario" class="col-12 col-md-6 px-1">
                    <b-form-input id="cpfUsuario" placeholder="000.000.000-00" :state="state.cpf" v-model="form.cpf" v-mask="['###.###.###-##']" :disabled="usuarioId != null" />
                    <b-form-invalid-feedback :state="state.cpf">{{validateMessage.cpf}}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Status" label-for="statusUsuario" class="col-12 col-md-6 px-1">
                    <b-form-select id="statusUsuario" v-model="form.disabled" :options="selectOptions"></b-form-select>
                </b-form-group>
                
                <b-form-group label="Celular" label-for="phoneUsuario" class="col-12 col-md-6 px-1">
                    <b-form-input id="phoneUsuario" placeholder="(99) 99999-9999" :state="state.phone" v-model="form.phone" v-mask="['(##) #####-####']" />
                    <b-form-invalid-feedback :state="state.phone">{{validateMessage.phone}}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Autenticação de dois fatores?" label-for="mfaActiveUsuario" class="col-12 col-md-6 px-1">
                    <b-form-select id="mfaActiveUsuario" v-model="form.mfaActive" :options="mfaActiveOptions"></b-form-select>
                </b-form-group>

                <div class="col-12 col-md-12 px-1 mb-2 ">
                    <EmpresaGroup v-if="isUserReport && form && form.flgReportUser" :showId="true" :empresas="form.empresasRelatorio" label="Empresa Relatório" id="add-empresa-Relatorio" keyString="empresasRelatorio"
                            @add="addEmpresa" @remove="removeEmpresa"/>

                    <EmpresaGroup  v-if="isUserReport && form && form.flgReportUserGestorGrupo" :isGroup="true" :showId="true" :empresas="form.gruposRelatorio" label="Grupo Relatório" id="add-grupo-Relatorio" keyString="gruposRelatorio"
                            @add="addEmpresa" @remove="removeEmpresa"/>
                
                    <EmpresaGroup :empresas="form.empresas" label="Empresa Carga" id="add-empresa" keyString="empresas"
                                @add="addEmpresa" @remove="removeEmpresa"/>
                </div>

                <b-form-group v-if="isUserReport" label="Tipo Sub-perfil Relatório" label-for="sub-perfil-relatorio" class="col-12 col-md-6 px-1">
                    <b-form-checkbox v-model="form.flgReportUserGestorGrupo" inline>
                        Gestor Grupo
                    </b-form-checkbox>	
                    <b-form-checkbox v-model="form.flgReportUser" inline>
                        Usuário Relatório
                    </b-form-checkbox>			
                </b-form-group>

                <b-form-group label="Solicitar alteração do MFA?" v-slot="{ ariaDescribedby }" id="radio-btn-password-usuario" class="col-12 col-md-12 px-1 mb-2">
                    <b-form-radio v-model="form.resetPhone" :aria-describedby="ariaDescribedby" name="reset-phone" :value="true">Sim</b-form-radio>
                    <b-form-radio v-model="form.resetPhone" :aria-describedby="ariaDescribedby" name="reset-phone" :value="false">Não</b-form-radio>
                </b-form-group>

                <b-form-group label="Deseja alterar a senha deste usuário?" v-slot="{ ariaDescribedby }" v-if="usuarioId != null" id="radio-btn-password-usuario">
                    <b-form-radio v-model="editSenha" :aria-describedby="ariaDescribedby" name="some-radios" :value="true">Sim</b-form-radio>
                    <b-form-radio v-model="editSenha" :aria-describedby="ariaDescribedby" name="some-radios" :value="null">Não</b-form-radio>
                </b-form-group>

                <div class="last-div row m-0 w-100 mt-2" v-if="editSenha != null">
                    <b-form-group label="Nova senha" label-for="senha">
                        <b-form-input id="senha" placeholder="Digite aqui" :state="state.password" v-model="form.password" trim />
                        <b-form-invalid-feedback :state="state.password" style="width: 100%">
                            {{validateMessage.password}}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Confirmar senha" label-for="confirmar-senha">
                        <b-form-input id="confirmar-senha" placeholder="Digite aqui" :state="state.password" v-model="confirmPassword" trim/>
                    </b-form-group>
                </div>
            </div>           

            <template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn optum-bold mr-2 py-15" @click="$bvModal.hide('adicionar-usuario')">Cancelar</b-button>
                <b-button pill class="btn-base primary-btn" @click="request">Salvar</b-button>
            </template>	
        </b-modal>

        <ModalAlert id="adicionar-usuario-success" size="sm" @close="handleClose">
            <DynamicIcon icon="check" :classString="'alert-exclamation'"/>
            {{usuarioId != null ? "Suas alterações foram salvas." : "Usuário cadastrado!"}}
        </ModalAlert>

    </div>	
</template>

<script>
import Validations from "@/util/Validations"
import EmpresaGroup from "./EmpresaGroup.vue"
import UserResource from "@/resources/UserResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalAlert from "@/components/commons/ModalAlert.vue"
import { maskCPF, maskPhoneNumber } from "@/util/StringUtils"

export default {
	name: "ModalFormuUsuario",
    props: { usuarioId : Number },
    components: {
        DynamicIcon,
        ModalAlert,
        EmpresaGroup
    },
    data() {
        return {
            validateMessage: {
                nome: null,
                email: null,
                cpf: null,
                phone: null,
                mfaActive: null,
                resetPhone: null,
                password: null,
                empresaAddition: null,
            },
            selectOptions : [
                { value: false, text: 'Ativo' },
                { value: true, text: 'Desabilitado' },
            ],
            mfaActiveOptions : [
                { value: false, text: 'Não' },
                { value: true, text: 'Sim' },
            ],
            form : { name: "", email: "", cpf: "", phone: "", mfaActive: true, resetPhone: false, disabled: false, flgReportUser: false, flgReportUserGestorGrupo: false, password: "password", empresas: [], empresasRelatorio: [], gruposRelatorio: []},
            empresaAddition: null,
            confirmPassword : null,
            editSenha : null,
        }        
    },
    computed: {
        isUserReport () {
            if ( this.form.profiles ) {
                return this.form.profiles.some(profile => profile.authority === "ROLE_UTILIZACAO_MENSAL");
            }   
            return false;
        },
        state() {
            return {
                nome: this.validateMessage.nome ? false : null,
                email: this.validateMessage.email ? false : null,
                cpf: this.validateMessage.cpf ? false : null,
                password: this.validateMessage.password ? false : null,
                empresaAddition: this.validateMessage.empresaAddition ? false : null,
                phone: this.validateMessage.phone ? false : null,
                mfaActive: this.validateMessage.mfaActive ? false : null,
                resetPhone: this.validateMessage.resetPhone ? false : null
            }
        }          
    },
    methods:{
        validateForm() {

            this.validateMessage = {
                nome: null,
                email: null,
                cpf: null,
                phone: null,
                mfaActive: null,
                resetPhone: null,
                password: null,
                empresaAddition: null
            };

            let nomeCompleto = this.form.name.split(" ")

            if ( !this.form.name.length ) {
                this.validateMessage.nome = "Este campo é obrigatório."
            }
            else if ( nomeCompleto.length < 2 || nomeCompleto[0].length < 2 || nomeCompleto[1].length < 2 || nomeCompleto[0].match(".*[@#$%^&+=!].*") ) {
                this.validateMessage.nome = "Por favor, informe nome e sobrenome válidos."
            }
            else { 
                this.validateMessage.nome = null 
            }
            
            if(this.form.mfaActive || this.form.phone)
            {
                this.validateMessage.phone = Validations.cellPhone( this.form.phone, !this.form.resetPhone)
            }

            this.validateMessage.email = Validations.email( this.form.email, true)      
            
            if(this.usuarioId == null)
            {
                this.validateMessage.cpf = Validations.cpf( this.form.cpf, false)
            }

            if ( this.editSenha != null ) {
                if ( Validations.isStringBlank(this.form.password) ) {
                    this.validateMessage.password = 'Este campo é obrigatório.'
                } else if ( Validations.password( this.form.password ) ) {
                    this.validateMessage.password = 'Senha não atende aos critérios de segurança.'
                } else if ( this.confirmPassword != this.form.password ) {
                    this.validateMessage.password = 'Senhas não conferem.'
                }
            }

            this.validateMessage.empresaAddition = this.empresaAddition != null ? 'É necessário clicar no botão + ao lado da lista para associar uma empresa.' : null
            
            return Validations.isEmpty( this.validateMessage )

        },
        request(){
            if ( !this.validateForm() ) {
                return 
            }

            let form = {
                ...this.form,
                cpf: this.form.cpf && this.form.cpf.replaceAll("-","").replaceAll(".","")
            }

            if( this.usuarioId != null) {
                UserResource.edit(this.usuarioId, form, {context: "userFormEdit", showLoader: true})
                .then(() => {
                    this.$bvModal.show('adicionar-usuario-success')
                })
                .catch((response) => {
                    this.fillResponseValidations(response)
                })
            }
            else {
                UserResource.save(form, {context: "userForm", showLoader: true})
                .then(() => {
                    this.$bvModal.show('adicionar-usuario-success')
                })
                .catch((response) => {
                    this.fillResponseValidations(response)
                })
            }            
        },
        fillResponseValidations(response)
        {
            this.validateMessage.nome = Validations.getHttpFieldMessage(response, "name")
            this.validateMessage.email = Validations.getHttpFieldMessage(response, "email")
            this.validateMessage.cpf = Validations.getHttpFieldMessage(response, "cpf")
            this.validateMessage.password = Validations.getHttpFieldMessage(response, "password")
        },
        hide(){
            this.$emit('updated')
            this.$bvModal.hide('adicionar-usuario')
        },
        addEmpresa(key, empresa) {
            this.form[key] = this.form[key].concat(empresa)
        },
        removeEmpresa(key, empresa) {
            this.form[key] = this.form[key].filter(e => e.id != empresa.id)
        },
		handleClose() {
			this.$bvModal.hide('adicionar-usuario')
		}
    },
    created(){
        if( this.usuarioId != null )
            UserResource.get(this.usuarioId, {context: "userFormEdit", showLoader: true})
            .then((user) => {
                this.form = { ...user, login: maskCPF(user.login), phone: maskPhoneNumber(user.phone)}
            })
        }
    }
</script>

<style lang="scss">
.modal-form-width {
    max-width: 740px;
    height: auto;
    background-color: #FBF9F4;
}
#nomePerfil, #descricaoPerfil{
    border: 1px solid #bbbec0 !important;
    overflow-y: auto !important;
}

html body .empresa-adder .empresa-adder-btn {
    background-color: $primaryBgColor;
    border: none;
}

html body .empresa-adder .empresa-adder-btn .empresa-adder-btn-plus{
    height: 25px;
    width: 25px;
}

html body .empresa-adder .empresa-adder-btn:hover {
    background-color: $secundaryBgColor;
    border: none;
}

html body .empresa-adder-list{
    flex-direction: row;
}

html body .empresa-adder-list-item{
    font-size: 12px;
    width: fit-content;
    border-radius: 50px;
    border: none;
    background-color: $secundaryBgColor;
    color: $whiteColor;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

html body .empresa-adder-list-item-btn-remove{
    background-color: transparent;
    padding: 0px;
    border: none;
}

html body .empresa-adder-list-item-btn-remove:hover{
    background-color: transparent;
}

html body .list-group-item:last-child {
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
}

html body .list-group-item:first-child {
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
}

.adicionar-perfil-sub-header{
    padding-bottom: 5px !important;
}

.adicionar-perfil-sub-body{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px !important;
    text-align: center;
}

.x-circle{
    color: #E32315;
    font-size: 53px;
    margin-bottom: 15px;
}

.check-circle{
    color: #627D32;
    font-size: 53px;
    margin-bottom: 15px;
}

#radio-btn-password-usuario div{
    display: flex;
}

#radio-btn-password-usuario legend{
    font: normal normal bold 12px/24px !important;
    color: #434448 !important;
}

#radio-btn-password-usuario div .custom-radio{
    margin-right: 10px;
}

#radio-btn-password-usuario div .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #434448;
    background-color: #434448;
}

.empresa-adder .v-select {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    width: 92%;
}

.empresa-list {
    margin-top: 20px;
}

.empresa-list button {
    float: right;
}
</style>

<style scoped>
input, select{
    border: 1px solid #bbbec0 !important;  
}

select{
    font-size: 14px !important;  
}

.last-div{
    display:flex;
    justify-content: space-between;
}

.last-div div{
    width: 48%
}

</style>